// Where the CLI points, and the clusters it knows by name.

/**
 * The Flowrunner clusters, by short name.
 *
 * A named table rather than free-form URLs so that `flowrunner use dev` is a typo-proof way to move a
 * project between them: a name that is not in here is refused, where a mistyped URL would be accepted and
 * only fail later, against a server that does not exist.
 */
export const CLUSTERS = {
  prod : 'https://app.flowrunner.ai',
  dev  : 'https://dev.flowrunner.ai',
  local: 'http://localhost:3000',
} as const

export type ClusterName = keyof typeof CLUSTERS

/**
 * The cluster a fresh project points at.
 *
 * One line, deliberately: moving the default from local to dev to prod as the product ships should not mean
 * hunting for a URL literal in half a dozen places.
 */
export const DEFAULT_CLUSTER: ClusterName = 'prod'

/**
 * The console a project talks to when it has not been told otherwise.
 *
 * A fresh project must be able to run `login` before anything has written `flowrunner.json` — asking the
 * user for a URL they have no way of knowing is the one thing a first run cannot afford.
 */
export const DEFAULT_SERVER_URL: string = CLUSTERS[DEFAULT_CLUSTER]

/** Overrides the default without editing the project file — how you point the CLI at a local console. */
export const SERVER_URL_ENV = 'FLOWRUNNER_SERVER_URL'
